// src/components/Header.js (シンプル版)
import React from 'react';

const Header = () => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50 transition-all duration-300 ease-in-out">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center sm:justify-start h-20 sm:h-24"> {/* 高さを少し持たせ、スマホでは中央寄せ、PCでは左寄せの例 */}
          {/* アプリ名 / ロゴ */}
          <a
            href="/"
            className="text-3xl sm:text-4xl font-extrabold tracking-tight text-gray-900 group"
          >
            投資
            <span className="text-blue-600 group-hover:text-blue-500 transition-colors duration-300">
              用語
            </span>
            集
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="inline-block h-8 w-8 ml-2 text-yellow-400 group-hover:rotate-12 transition-transform">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
            </svg>
          </a>
        </div>
      </div>
      {/* ヘッダー下部にアクセントラインを入れる例 */}
      <div className="h-1 bg-gradient-to-r from-blue-500 to-indigo-600"></div>
    </header>
  );
};

export default Header;